module.exports = __webpack_public_path__ + "media/checkmarks/blue-checkmark-transparent-bg-3a661189.svg";